import React from "react";
import "../workexperience/workExperience.css";
import InquiryForm from "../InquiryForm";

const WorkExperienceUSA = () => {
  return (
    <div className="work-experience-container">

      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>International Work Experience in U.S.A</h1>
          <p>
            Gain invaluable international work experience in the United States, the world's largest 
            economy and a global hub for innovation, technology, and business. From Silicon Valley 
            to Wall Street, the USA offers unmatched opportunities for professional growth and 
            career advancement.
          </p>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1485738422979-f5c462d49f74?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
            alt="Work in USA - New York City"
          />
        </div>
      </section>

      {/* DEFINITION SECTION */}
      <section className="definition-section">
        <h2>What is Work Experience?</h2>
        <p>
          Gaining international work experience in Europe can be a great way to boost your career. 
          To achieve this, you can explore various options such as internships, work exchanges, 
          or direct employment. Consider starting with researching job markets, building a strong 
          resume, improving language skills, networking, and applying for necessary visas.
        </p>
        <p>
          The economies of many European countries are not only robust but diverse, offering a wide 
          variety of opportunities for those looking for internships in Europe. Landmark cities and 
          economic goliaths such as Paris, Berlin, Madrid, London, and more call people from all 
          corners of the globe to engage in their thriving business sectors.
        </p>
        <p>
          Not only does an internship in Europe offer you the chance to experience beautiful landscapes 
          and unique culinary cultures, but you'll also gain first-hand experience and build an 
          international network in locations where its rich culture not only embraces but precedes 
          mass globalization.
        </p>
      </section>

      {/* HIGHLIGHTS SECTION */}
      <section className="highlights-section">
        <h2>Why Choose USA?</h2>
        <div className="highlights-grid">
          <div className="highlight-card">
            <h3>🌍 Global Leadership</h3>
            <p>Opportunity to work in the world's largest economy with global industry leaders.</p>
          </div>

          <div className="highlight-card">
            <h3>🚀 Early Career Advantage</h3>
            <p>Get an opportunity to work at international level right at the beginning of your career.</p>
          </div>

          <div className="highlight-card">
            <h3>👥 Expert Mentorship</h3>
            <p>Get real work experience under the guidance of world-class seniors and industry pioneers.</p>
          </div>

          <div className="highlight-card">
            <h3>📚 Advanced Learning</h3>
            <p>It helps to improve your skills and knowledge through cutting-edge work environments.</p>
          </div>

          <div className="highlight-card">
            <h3>💰 Competitive Compensation</h3>
            <p>You also get monthly salary / stipend with some of the highest pay scales globally.</p>
          </div>

          <div className="highlight-card">
            <h3>⚡ Professional Growth</h3>
            <p>It makes you ready to face challenges in this competitive global market.</p>
          </div>

          <div className="highlight-card">
            <h3>🎯 Universal Applicability</h3>
            <p>Helpful for fresher and even for experienced professionals seeking global exposure.</p>
          </div>

          <div className="highlight-card">
            <h3>🌐 Global Recognition</h3>
            <p>Help to work at international level with globally recognized work experience.</p>
          </div>

          <div className="highlight-card">
            <h3>💪 Confidence Enhancement</h3>
            <p>It improves your confidence by exposing you to diverse work environments and challenges.</p>
          </div>

          <div className="highlight-card">
            <h3>📄 Powerful Resume</h3>
            <p>It makes your resume strong with valuable international work experience from USA.</p>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="benefits-section">
        <h2>Key Benefits</h2>
        <ul className="benefits-list">
          <li>Work with global industry leaders</li>
          <li>Access to cutting-edge technology and innovation</li>
          <li>OPT and STEM OPT opportunities</li>
          <li>Highest salary packages globally</li>
          <li>Diverse and dynamic work culture</li>
          <li>Networking with industry pioneers</li>
          <li>Pathway to H1B visa sponsorship</li>
          <li>Exposure to Fortune 500 companies</li>
        </ul>
      </section>

      {/* OPPORTUNITIES SECTION */}
      <section className="opportunities-section">
        <h2>Work Opportunities</h2>
        <div className="opportunity-grid">
          <div className="opportunity-item">
            <h3>💻 Technology</h3>
            <p>Silicon Valley, Seattle, Austin - Tech innovation hubs</p>
          </div>
          <div className="opportunity-item">
            <h3>💰 Finance</h3>
            <p>Wall Street, Chicago - Global financial centers</p>
          </div>
          <div className="opportunity-item">
            <h3>🎬 Entertainment</h3>
            <p>Hollywood, LA - Media and entertainment industry</p>
          </div>
          <div className="opportunity-item">
            <h3>⚕️ Healthcare</h3>
            <p>World-class hospitals and research centers</p>
          </div>
        </div>
      </section>

      {/* COUNTRIES SECTION */}
      <section className="countries-section">
        <h2>Major Work Destinations</h2>
        <div className="countries-list">
          <span className="country-tag">🇺🇸 New York</span>
          <span className="country-tag">🇺🇸 San Francisco</span>
          <span className="country-tag">🇺🇸 Los Angeles</span>
          <span className="country-tag">🇺🇸 Chicago</span>
          <span className="country-tag">🇺🇸 Boston</span>
          <span className="country-tag">🇺🇸 Seattle</span>
          <span className="country-tag">🇺🇸 Austin</span>
          <span className="country-tag">🇺🇸 Miami</span>
        </div>
      </section>

      {/* INQUIRY FORM */}
      <InquiryForm title="Inquire About Work Experience in USA" />

    </div>
  );
};

export default WorkExperienceUSA;